import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConfirmationModal.css';

interface ConfirmationModalProps {
    isOpen: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
    isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
    isLoading = false,
}) => {
    const { t } = useTranslation();
    
    if (!isOpen) return null;

    return (
        <div className="confirmation-modal-overlay" onClick={isLoading ? undefined : onCancel}>
            <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
                <h3 className="confirmation-modal-title">{title}</h3>
                <p className="confirmation-modal-message">{message}</p>
                {isLoading && (
                    <div className="confirmation-modal-loader">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">{t('common.loading')}</span>
                        </div>
                    </div>
                )}
                <div className="confirmation-modal-actions">
                    <button
                        className="confirmation-modal-btn confirm"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {confirmText || t('common.yes')}
                    </button>
                    <button
                        className="confirmation-modal-btn cancel"
                        onClick={onCancel}
                        disabled={isLoading}
                    >
                        {cancelText || t('common.no')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
